import React from 'react'
import Head from 'next/head'
import Page from '../components/Page'
import RowList from '../components/Main/RowList'
import Accordion from '../components/Main/Accordion'

export default function Faqs (props) {
  const { faq_section: faqSection } = props.acf
  const fullArticle = props.wp

  return (
    <React.Fragment>
      <Page
        title={fullArticle.title.rendered}
        slug={fullArticle.slug}
        body={
          'A list of employment opportunities, either to work for The Quell Foundation itself, or one of its partner organizations.'
        }
      >
        <main id='content'>
          <div className='container single-page'>
            <RowList singlePage title={props.wp.title.rendered} />
            <Accordion section={faqSection} />
          </div>
        </main>
      </Page>
    </React.Fragment>
  )
}
